export default __webpack_public_path__ + "static/media/plus6-12.b9733025.png";